import React from "react";

const WHATSAPP_NUMBER = "917411605384";
const MESSAGE = "Hello, I would like to know more about your services.";

const WhatsAppFloating: React.FC = () => {
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    MESSAGE
  )}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-[9999]"
    >
     
        {/* GREEN BUTTON */}
        <div className="flex h-[56px] w-[56px] items-center justify-center rounded-full bg-[#25D366]">
          {/* WHATSAPP ICON */}
          <svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  fill="white"
  className="h-7 w-7"
>
  <path d="M20.52 3.48A11.86 11.86 0 0 0 12.06 0C5.46 0 .12 5.34.12 11.94c0 2.1.54 4.14 1.56 5.94L0 24l6.3-1.62a11.9 11.9 0 0 0 5.76 1.47h.01c6.6 0 11.94-5.34 11.94-11.94 0-3.18-1.23-6.18-3.49-8.43ZM12.06 21.9a9.9 9.9 0 0 1-5.04-1.38l-.36-.21-3.75.99 1-3.66-.24-.38a9.88 9.88 0 0 1-1.53-5.22c0-5.46 4.44-9.9 9.9-9.9a9.82 9.82 0 0 1 6.99 2.91 9.82 9.82 0 0 1 2.91 6.99c0 5.46-4.44 9.9-9.9 9.9Zm5.43-7.44c-.3-.15-1.77-.87-2.04-.96-.27-.09-.47-.15-.66.15-.2.3-.76.96-.93 1.17-.17.21-.34.24-.64.09-.3-.15-1.26-.46-2.4-1.47-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.3.3-.49.1-.19.05-.36-.02-.51-.07-.15-.66-1.59-.91-2.18-.24-.58-.49-.5-.66-.51h-.57c-.2 0-.51.07-.78.36-.27.3-1.02 1-1.02 2.44s1.05 2.83 1.2 3.03c.15.2 2.07 3.16 5.01 4.43.7.3 1.25.48 1.68.62.71.23 1.35.2 1.86.12.57-.08 1.77-.72 2.02-1.38.25-.66.25-1.23.17-1.35-.08-.12-.27-.19-.57-.34Z"/>
</svg>

        </div>
      
    </a>
  );
};

export default WhatsAppFloating;
